/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionnopushbeforemorning4Inputs */

const en_actionnopushbeforemorning4 = /** @type {(inputs: Actionnopushbeforemorning4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ends before 8 am: it goes out without a push but shows on your place page and in the feed.`)
};

const de_actionnopushbeforemorning4 = /** @type {(inputs: Actionnopushbeforemorning4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endet vor 8 Uhr: Sie geht nicht als Mitteilung raus, steht aber auf deiner Ortsseite und im Feed.`)
};

/**
* | output |
* | --- |
* | "Ends before 8 am: it goes out without a push but shows on your place page and in the feed." |
*
* @param {Actionnopushbeforemorning4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionnopushbeforemorning4 = /** @type {((inputs?: Actionnopushbeforemorning4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionnopushbeforemorning4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionnopushbeforemorning4(inputs)
	return de_actionnopushbeforemorning4(inputs)
});
export { actionnopushbeforemorning4 as "actionNoPushBeforeMorning" }